// extracted by mini-css-extract-plugin
export default {"header":"PA","discountBanner":"QA","logo":"RA","maincontainer":"SA","videocontainer":"TA","videowelcome":"UA","videowrapper":"VA","videosale":"WA","loadingcontainer":"XA","footer":"YA","footerbutton":"ZA","video":"aB","logoname":"bB"};
    if(module.hot) {
      // 1714442369225
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  